import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { usePageView } from '@fs/zion-analytics'
import { H5 } from '@fs/zion-ui'
import { usePageTitle } from '../app/PageTitleContext'
import { PermissionsContext } from '../app/PermissionsContext'
import SubnavAndRoutes from '../app/SubnavAndRoutes'
import ArtifactInfo from './ArtifactInfo'
import DownloadPatronArtifacts from './DownloadPatronArtifacts'
import EscalatedArtifacts from './EscalatedArtifacts'
import PatronArtifacts from './PatronArtifacts'
import RecentArtifacts from './RecentArtifacts'
import SearchArtifacts from './SearchArtifacts'
import SearchBar from './SearchBar'

export default function ArtifactsBase() {
  usePageView({ page_detail: 'DMConsole:ArtifactsBase' })
  const [t] = useTranslation()
  usePageTitle(t('pageTitle.artifacts.base'))
  const subNavs = [
    {
      text: t('artifacts.recent', 'Recent'),
      path: 'recent',
      requiredPermissions: [],
      component: RecentArtifacts,
    },
    {
      text: t('artifacts.escalated', 'Escalated'),
      path: 'escalated',
      requiredPermissions: [],
      component: EscalatedArtifacts,
    },
    {
      path: 'patron/:userQuery/:artifactCategory',
      requiredPermissions: [],
      component: PatronArtifacts,
    },
    {
      path: 'patron/:userQuery',
      requiredPermissions: [],
      component: PatronArtifacts,
    },
    {
      path: 'patronDownload/:userQuery/:deleted',
      requiredPermissions: [],
      component: DownloadPatronArtifacts,
    },
    {
      path: 'artifact/:artifactId',
      requiredPermissions: [],
      component: ArtifactInfo,
    },
    {
      path: 'tombstoned/:patronId/:artifactId',
      requiredPermissions: [],
      component: ArtifactInfo,
    },
    {
      path: 'search/:searchTerms/:artifactCategory',
      requiredPermissions: [],
      component: SearchArtifacts,
    },
    {
      path: 'search/:searchTerms',
      requiredPermissions: [],
      component: SearchArtifacts,
    },
    {
      text: t('action.search', 'Search'),
      path: 'search',
      requiredPermissions: [],
      component: SearchBar,
    },
  ]

  const { isAuthorized } = useContext(PermissionsContext)
  if (!isAuthorized('ArtPrmCanReview')) {
    return <H5>{t('not.authorized.greeting', 'Not authorized')}</H5>
  }

  return <SubnavAndRoutes data={subNavs} defaultPath="recent" />
}
